export default __webpack_public_path__ + "640d7b8f9e6bf6211812262afeb78dec.png";